import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './App.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Header from './Component/Header/Header';
import Footer from './Component/Footer/Footer';
import HomePage from './Component/Pages/HomePage';
import AboutUs from './Component/Pages/AboutUs';
import OctopussJobs from './Component/Pages/OctopussJobs';
import OctopussTechnology from './Component/Pages/OctopussTechnology';
import OctopussEvents from './Component/Pages/OctopussEvents';
import OctopussRetails from './Component/Pages/OctopussRetails';
import OctopussSecurity from './Component/Pages/OctopussSecurity';
import OctopussInfratructure from './Component/Pages/OctopussInfratructure';
import OctopussFacilityManagement from './Component/Pages/OctopussFacilityManagement';
import OurClients from './Component/Pages/OurClients';
import Gallery from './Component/Pages/Gallery';
import ContactUs from './Component/Pages/ContactUs';



function App() {
  return (
    <>
      <ToastContainer />
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<HomePage/>}/>
          <Route path="/About-us" element={<AboutUs/>}/>
           <Route path="/Octopuss-Jobs" element={<OctopussJobs/>}/>
           <Route path="/Octopuss-Technologies" element={<OctopussTechnology/>}/>
           <Route path="/Octopuss-Events" element={<OctopussEvents/>}/>
           <Route path="/Octopuss-Retails" element={<OctopussRetails/>}/>
           <Route path="/Octopuss-Infratructure" element={<OctopussInfratructure/>}/>
           <Route path="/Octopuss-Security" element={<OctopussSecurity/>}/>
           <Route path="/Facility-Management-System" element={<OctopussFacilityManagement/>}/>
           <Route path="/Our-Clients" element={<OurClients/>}/>
           <Route path="/Gallery" element={<Gallery/>}/>
           <Route path="/Contact-Us" element={<ContactUs/>}/>
           

        </Routes>
        <Footer />
      </BrowserRouter>
    </>
  );
}

export default App;
